import * as React from 'react'

import ModuleCard from './ModuleCard'
import IconType from '../../atoms/Icon/iconTypes'
import { colours } from '../../config/theme'

export const CarePlansModuleCard = () => (
  <ModuleCard
    backgroundColor={colours.status.popout}
    icon={IconType.CarePlansHexagon}
    link="/"
    linkText="Find out more"
    subtitle="Create personalised care and support plans using our easy-to-use templates."
    title="Support Plans"
    onClick={() =>
      window.open('https://logmycare.co.uk/features/care-delivery#care_plans')
    }
  />
)
